import React from 'react';
import _ from 'lodash';
import Autosuggest from 'react-autosuggest';
import { userService } from '../_services';
import { withRouter } from 'Components/withRouter';
import styles from './FrequentAddressEditForm.module.css';

class FrequentAddressEditForm extends React.Component {
    constructor(props) {
        super(props);

        var initialState = {
            isNew: props.isNew,
            id: '',
            account: '',
            contact: '',
            phone: '',
            company: '',
            address1: '',
            address2: '',
            suburb: '',
            key: '',
            suburbSuggestions: []
        };

        if (props.edit_address != null && props.edit_address != undefined) {
            Object.assign(initialState, {
                id: props.edit_address.id,
                account: props.edit_address.account,
                contact: props.edit_address.contact,
                phone: props.edit_address.phone,
                company: props.edit_address.company,
                address1: props.edit_address.address1,
                address2: props.edit_address.address2,
                suburb: props.edit_address.suburb,
                key: props.edit_address.customer_key
            });
        }
        
        this.state = initialState;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);

        this.handleSuburbChange = this.handleSuburbChange.bind(this);
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: (event.target.type === 'checkbox') ? event.target.checked: event.target.value
        })
    }

    handleSubmit(event) {
        event.preventDefault();

        const formData = new FormData(document.getElementById('frequentAddressEditForm'));
        this.props.onFormSubmit(formData);
    }

    handleCancel() {
        this.props.router.navigate(-1);
    }

    handleSuburbChange(event, { newValue, method }) {

        if (event && event.target && event.target.name) {
            this.setState({
                [event.target.name]: newValue
            });
        }
    }

    onSuggestionsFetchRequested({ value, reason }) {
        
        var inputValue = value.trim().toLowerCase();
        var suggestions = _.filter(
            this.props.suburbs,
            s => s.toLowerCase().indexOf(inputValue) !== -1
            )
            .slice(0, 10);

        this.setState({
            suburbSuggestions: suggestions
        });
        
    }

    onSuggestionsClearRequested() {
        this.setState({
            suburbSuggestions: []
        });
    }

    onSuggestionSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
        
        if (method === 'click') {
            this.setState({
                suburb: suggestion
            });
        }
    }

    getSuggestionValue(suggestion) {
        return suggestion;
    }

    renderSuggestion(suggestion, { query, isHighlighted }) {
        return (<div>{suggestion}</div>);
    }

    onAutoSuggestKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    }

    render() {

        var accountField = null;

        if(this.state.isNew === true) {

            var accountOptions = null;

            if (this.props.accountOptions !== undefined && this.props.accountOptions !== null) {
                var sortedAccounts = _.sortBy(this.props.accountOptions, ['label']);
                accountOptions = sortedAccounts.map(
                    (a) => <option key={a.value} value={a.value}>{a.label}</option>
                    );
            }

            accountField = (
                <div className="form-group form-group-sm">
                    <label>*Account</label>
                    <select className="form-control" name="account" value={this.state.account} onChange={this.handleChange}>
                        {accountOptions}
                    </select>
                </div>
            );
        } else {
            accountField = (<input type="hidden" name="account" value={this.state.account} onChange={this.handleChange} />)
        }

        return (
            <form id="frequentAddressEditForm" styleName="styles.form" onSubmit={this.handleSubmit}>
                <input id="inputAddressId" name="id" type="hidden" value={this.state.id} />
                <div className="row">
                    <div className="col-xs-12 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
                        {accountField}
                        <div className="form-group form-group-sm">
                            <label>Contact</label>
                            <input type="text" className="form-control" name="contact" value={this.state.contact} onChange={this.handleChange} />
                        </div>
                        <div className="form-group form-group-sm">
                            <label>Phone</label>
                            <input type="text" className="form-control" name="phone" value={this.state.phone} onChange={this.handleChange} />
                        </div>
                        <div className="form-group form-group-sm">
                            <label>*Company</label>
                            <input type="text" className="form-control" required name="company" value={this.state.company} onChange={this.handleChange} />
                        </div>
                        <div className="form-group form-group-sm">
                            <label>*Address</label>
                            <input type="text" className="form-control" required name="address1" value={this.state.address1} onChange={this.handleChange} />
                        </div>
                        <div className="form-group form-group-sm">
                            <label></label>
                            <input type="text" className="form-control" name="address2" value={this.state.address2} onChange={this.handleChange} />
                        </div>
                        <div className="form-group form-group-sm">
                            <label>*Suburb</label>
                            <Autosuggest
                                suggestions={this.state.suburbSuggestions}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                onSuggestionSelected={this.onSuggestionSelected}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={{
                                    className: "form-control",
                                    type: "text",
                                    name: "suburb",
                                    value: this.state.suburb,
                                    onChange: this.handleSuburbChange,
                                    onKeyDown: this.onAutoSuggestKeyDown
                                }}
                                />
                        </div>
                        <div className="form-group form-group-sm">
                            <label>Customer Key</label>
                            <input type="text" className="form-control"  name="key" value={this.state.key} onChange={this.handleChange} />
                        </div>
                        <button type="submit" className="btn btn-default btn-dl-green">SAVE</button>
                        <button type="button" className="btn btn-defualt btn-dl-green margin-lr10" onClick={this.handleCancel}>CANCEL</button>
                    </div>
                </div>
            </form>
            )
    }
}

export default withRouter(FrequentAddressEditForm);